import React from 'react';
import PropTypes from 'prop-types';
import { AutoplayCarousel } from '../AutoplayCarousel';
import styles from './PlanStatsList.css';

const DEFAULT_STATS = [
    {
        id: 1,
        percent: '79%',
        description: 'of Americans want to know more about their parents’ lives.',
        highlight: <>Give Mom a place to tell <strong>her story</strong>.</>
    },
    {
        id: 2,
        percent: '37%',
        description: 'know much about their mother’s life before they were born.',
        highlight: <strong>Give her a place to tell it.</strong>
    },
    {
        id: 3,
        percent: '53%',
        description: 'of us can’t name all four of our grandparents.',
        highlight: <strong>Start with the one you can still ask.</strong>
    }
];

function PlanStatsList({ stats = DEFAULT_STATS }) {
    return (
        <AutoplayCarousel className={styles.carousel}>
            {stats.map(stat => (
                <div className={styles.slide} key={stat.id}>
                    <p className={styles.percent}>{stat.percent}</p>
                    <p className={styles.description}>{stat.description}</p>
                    <p className={styles.highlight}>{stat.highlight}</p>
                </div>
            ))}
        </AutoplayCarousel>
    );
}

PlanStatsList.propTypes = {
    stats: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        percent: PropTypes.string,
        description: PropTypes.node,
        highlight: PropTypes.node
    }))
};

export {
    PlanStatsList
};
